import { CaseTemplate } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceCaseTemplateAction, deleteCaseTemplateAction, setCaseTemplatesAction } from '../reducers/caseTemplateReducer';

export const useCaseTemplateActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceCaseTemplate = (caseTemplate: CaseTemplate) => {
        dispatch(addOrReplaceCaseTemplateAction(caseTemplate));
    }

    const setCaseTemplates = (caseTemplates: CaseTemplate[]) => {
        dispatch(setCaseTemplatesAction(caseTemplates));
    }

    const deleteCaseTemplate = (caseTemplate: CaseTemplate) => {
        dispatch(deleteCaseTemplateAction(caseTemplate.templateId!));
    }

    const removeCaseTemplate = (templateId: string) => {
        dispatch(deleteCaseTemplateAction(templateId));
    }

    return { addOrReplaceCaseTemplate, setCaseTemplates, deleteCaseTemplate, removeCaseTemplate };
}
